export default class FullscreenApiAdapter {
  static fullscreenElement() {
    return (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    );
  }

  static exitFullscreen() {
    if (this.fullscreenElement() !== null && this.fullscreenElement() !== undefined) {
      if (document.exitFullscreen) {
        return document.exitFullscreen();
      }

      if (document.webkitExitFullscreen) {
        return document.webkitExitFullscreen();
      }

      if (document.mozCancelFullscreen) {
        return document.mozCancelFullscreen();
      }

      if (document.msExitFullscreen) {
        return document.msExitFullscreen();
      }
    }
  }
}
